import { Descriptions } from "antd";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import { TypeAluno } from "../../../../../Models/Domain/Pessoa/Aluno";
import Utilitario from "../../../../../Utils/Utilitario";
import { EnumTipoDeDocumento } from "../../../../../Models/Domain/Pessoa/Enum";

export const DescricaoDoAluno: React.FC<{aluno: TypeAluno, ocultarTitulo?: boolean}> = (props) => {
    const aluno = props.aluno
    return <Descriptions
        bordered
        title={props.ocultarTitulo ? undefined : "Aluno"}
        column={1}
        items={[
            {
                key: "nome",
                label: "Nome",
                children: <>{aluno.pessoa?.nome ?? "N/A"}</>
            },
            {
                key: "cpf",
                label: "CPF",
                children: Formatacoes.formatarCPF(aluno.pessoa?.cpf) ?? "N/A"
            },
            aluno.pessoa?.passaporte? {
                key: "passaporte",
                label: "Passaporte",
                children: aluno.pessoa.passaporte
            } : undefined,
            {
                key: "documento",
                label: Utilitario.enumParaString(EnumTipoDeDocumento, aluno.tipoDeDocumento) ?? "Documento",
                children: aluno.documento ?? "N/A"
            },
            {
                key: "data-nascimento",
                label: "Data de nascimento",
                children: <>{Formatacoes.paraData(aluno.dataDeNascimento)?.toLocaleDateString() ?? "N/A"}</>
            },
        ].filter((v) => v != undefined)}
    />
}